import {
  Button,
  Col,
  Divider,
  Popover,
  Row,
  Space,
  Table,
  Typography,
  message,
} from "antd";
import {ExcelSVG} from "assets";
import {allocationMedicineService} from "api";
import {ColumnPopoverDisplay, ExpandSearch} from "components/common";
import Icons from "assets/icons";
import React, {useEffect, useRef, useState} from "react";
import {ColumnProps} from "types/models";
import {allColumns, inputFields} from "./config";
import {useAppSelector} from "redux/hooks";
import {useDispatch} from "react-redux";
import {tabKeys} from "types/enums";
import {
  setSelectedRecord,
  setActiveTabAllocation,
} from "redux/reducer/allocationMedicine";
import {
  formatDateOrStringToStringGMT_7,
  formatDateToString,
  removeObjUndefined,
} from "helper/common";
import Notification from "components/common/notification/notification";

const List = () => {
  const dispatch = useDispatch();
  const expandRef = useRef(null);
  const activeTabAllocation = useAppSelector(
    state => state.allocationMedicine.activeTabAllocation
  );
  const selectedRecord = useAppSelector(
    state => state.allocationMedicine.selectedRecord
  );
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState();
  const [columns, setColumns] = useState<ColumnProps[]>(
    allColumns.filter(e => e.show == true)
  );
  const [params, setParams] = useState<any>({
    page: page,
    limit: 10,
    // status: "CB",
  });
  useEffect(() => {
    if (activeTabAllocation == tabKeys.MEDICINE_STORE.ALLOCATION_LIST) {
      getList();
    }
  }, [activeTabAllocation]);
  const onKeyDown = e => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };

  useEffect(() => {
    getList();
  }, [params]);

  const getList = async () => {
    try {
      setLoading(true);
      const res = await allocationMedicineService.getList(params);
      const data = res.data.map(e => ({
        ...e.prescriptionDto,
        listPrescriptionDetailDto: e.listPrescriptionDetailDto,
        listPrescriptionSalesDto: e.listPrescriptionSalesDto,
        key: e.prescriptionDto.id,
      }));
      setTotal(res.total);
      setData(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi khi lấy danh sách đơn kê");
    }
    setSelectedRowKeys([]);
  };
  const setShowColumns = showColumns => {
    setColumns(showColumns);
  };
  const onChangePagination = (page, pageSize) => {
    setPage(1);
    setParams({...params, page: page, limit: pageSize});
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setSelectedRowKeys(selectedRowKeys);

      dispatch(setSelectedRecord(selectedRows[0]));
    },
  };
  const onClickSearch = () => {
    var searchFields = expandRef?.current?.getData();
    // searchFields = removeObjUndefined(searchFields);
    setParams({
      ...params,
      ...searchFields,
      startNgayTao: formatDateToString(searchFields?.startNgayTao),
      endNgayTao: formatDateToString(searchFields?.endNgayTao),
      ngaySinh: formatDateToString(searchFields?.ngaySinh),
    });
    setPage(1);
  };
  const onDetail = () => {
    dispatch(setActiveTabAllocation(tabKeys.MEDICINE_STORE.ALLOCATION_DETAIL));
  };
  return (
    <div className="list-allocation" onKeyDown={onKeyDown} tabIndex={0}>
      <div className="container">
        <ExpandSearch
          ref={expandRef}
          onClickSearch={onClickSearch}
          fields={inputFields}
          onReset={onClickSearch}
        ></ExpandSearch>
      </div>

      <div className="container">
        <Space style={{width: "100%"}} direction="vertical">
          <Typography.Text strong>Danh sách đơn thuốc kê</Typography.Text>
          <Divider type="horizontal" style={{margin: "0"}} />
          <Row justify={"space-between"} gutter={[16, 8]}>
            <Col>
              <Button className="excel-button">
                <Space align="center">
                  <ExcelSVG className="excel-icon-svg" />
                  <Typography>Xuất báo cáo</Typography>
                </Space>
              </Button>
            </Col>
            <Col>
              <Space style={{width: "100%"}}>
                <Popover
                  trigger="click"
                  placement="topLeft"
                  content={
                    <ColumnPopoverDisplay
                      setShowColumns={setShowColumns}
                      columns={allColumns}
                    ></ColumnPopoverDisplay>
                  }
                >
                  <Button icon={<Icons.bars />} className="btn-sub">
                    Cột hiển thị
                  </Button>
                </Popover>

                <Button
                  icon={<Icons.file />}
                  className="btn-sub"
                  onClick={() => {
                    if (selectedRecord) {
                      onDetail();
                    } else {
                      Notification("warning", "Chưa chọn đơn thuốc kê");
                    }
                  }}
                >
                  Chi tiết đơn thuốc
                </Button>
              </Space>
            </Col>
          </Row>
          <Table
            columns={columns}
            dataSource={data}
            pagination={{
              position: ["bottomRight"],
              showSizeChanger: true,
              current: page,
              total: total,
              onChange: onChangePagination,
            }}
            rowSelection={{
              type: "radio",
              ...rowSelection,
            }}
            bordered={true}
            loading={loading}
            onRow={(record, rowIndex) => {
              return {
                onDoubleClick: event => {
                  dispatch(setSelectedRecord(record));
                  dispatch(
                    setActiveTabAllocation(
                      tabKeys.MEDICINE_STORE.ALLOCATION_DETAIL
                    )
                  );
                }, // double click row
              };
            }}
          />
        </Space>
      </div>
    </div>
  );
};
export default List;
